// @ts-ignore
'use client';
import '@mux/mux-player/themes/microvideo';
export default 'microvideo';
